<template>
    <BaseTabs
        v-model="activeTabValue"
        animation="fade-scale"
        :tabs="tabs"
        :default-value="defaultTabValue">
        <BaseTab
            v-for="(tab, index) in items"
            :key="tab.id"
            force-mount
            animation="fade-scale"
            :value="getTabValue(tab, index)">
            <div class="flex w-full flex-col gap-10">
                <div
                    v-if="tab.image || tab.content"
                    class="flex h-full w-full flex-col justify-between gap-10 lg:flex-row">
                    <div
                        v-if="tab.image?.length"
                        class="flex items-stretch">
                        <div class="flex grow flex-col">
                            <div
                                class="sticky top-25 max-h-[31.5rem] w-full overflow-hidden rounded-12 lg:max-w-[38.75rem]">
                                <picture>
                                    <source
                                        v-if="tab.image[0].webp_url"
                                        type="image/webp"
                                        :srcset="
                                            getMediaLink(
                                                tab.image[0].webp_url || ''
                                            ) || ''
                                        " />
                                    <source
                                        v-else-if="
                                            !tab.image[0].webp_url &&
                                            !tab.image[0].url
                                        "
                                        srcset="
                                            /assets/images/ui/placeholder/webp/cromi.webp
                                        "
                                        type="image/webp" />
                                    <img
                                        loading="lazy"
                                        width="440"
                                        height="440"
                                        :alt="tab.image[0].alt || tab.name"
                                        :src="
                                            getMediaLink(
                                                tab.image[0].url || ''
                                            ) ||
                                            '/assets/images/ui/placeholder/jpg-png/cromi.png'
                                        "
                                        class="h-auto w-full object-cover transition-all duration-300 hover:scale-110" />
                                </picture>
                            </div>
                        </div>
                    </div>
                    <div
                        v-html="tab.content || ''"
                        :class="
                            tab.image?.length
                                ? 'basis-1/2'
                                : 'max-width-[70rem] w-full'
                        "
                        class="tinyeditor flex flex-col text-16/150 font-medium text-accent-100 transition-all duration-300" />
                </div>
                <div class="w-full">
                    <DocumentCard
                        :document="tab.document"
                        :title="tab.document.document_name" />
                </div>
            </div>
        </BaseTab>
    </BaseTabs>
</template>

<script setup lang="ts">
import BaseTab from '~/components/base/base-tabs/BaseTab.vue'
import BaseTabs from '~/components/base/base-tabs/BaseTabs.vue'
import type { IBaseTabsItem } from '~/components/base/base-tabs/base-tabs.types'
import DocumentCard from '~/components/base/document-card/DocumentCard.vue'
import type { CatalogProductBlock } from '~/components/pages/catalog/catalog-product/catalog-product.types'

const props = defineProps({
    items: {
        type: Array as PropType<CatalogProductBlock[]>,
        default: () => [],
    },
})

const activeTabValue = ref<string>(getTabValue(props.items[0], 0))

const tabs = computed<IBaseTabsItem[]>(() => {
    return props.items.map((tab: CatalogProductBlock, index: number) => ({
        value: getTabValue(tab, index),
        label: tab.name,
    }))
})

const defaultTabValue = computed<string>(() => tabs.value[0]?.value || '')

function getTabValue(tab: CatalogProductBlock, index: number): string {
    return `product-block-${tab.id ?? index}`
}
</script>
